<template>
  <section id="settings">
    <div class="container">
      <h1>Settings</h1>
      <hr>
      <ul class="nav nav-pills mb-2">
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: settingsTab === 'user' }"
            @click="settingsTab = 'user'"
          >User Settings</button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link btn btn-outline-light mr-2"
            :class="{ active: settingsTab === 'modules' }"
            @click="settingsTab = 'modules'"
          >Modules</button>
        </li>
      </ul>
      <div
        v-if="settingsTab === 'user'"
      >
        <transition name="fade">
          <div v-if="showSuccess" class="alert alert-success" style="position:fixed;top:20px;right:20px;width:200px;" role="alert">
            Profile updated!
          </div>
        </transition>

        <h2>Update Email Address</h2>
        <form @submit.prevent>
          <div class="form-group">
            <label>Email</label>
            <input class="form-control" v-model="newEmail" :placeholder="currentUser.email" />
          </div><!-- /.form-group -->
          <button class="btn btn-primary" @click="updateEmail()">Update Email</button>
        </form>
        <hr>
        <h2>Update Password</h2>
        <form @submit.prevent>
          <div class="form-group">
            <label>New Password</label>
            <input class="form-control" v-model="newPassword" type="password" placeholder="******" />
          </div><!-- /.form-group -->
          <button class="btn btn-primary" @click="updatePassword()">Update Password</button>
        </form>
        <hr>
        <button class="btn btn-warning" @click="logout()">Logout</button>
      </div><!-- /settingsTab === 'user' -->

      <!-- MODULES -->
      <div
        v-if="settingsTab === 'modules'"
      >
        <h4>Install Modules:</h4>
        <b-btn
          v-for="module in modules"
          v-bind:key="module.machine_name"
          v-if="!dashboard.data.modules[module.machine_name]"
          @click="installModule(module)"
        >
          {{ module.config.title }}
        </b-btn>
        <hr>

        <h4>Activate Installed Modules:</h4>
        <div
          class="form-check"
          v-for="module in modules"
          v-bind:key="module.machine_name"
          v-if="dashboard.data.modules[module.machine_name]"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-model="dashboard.data.modules[module.machine_name].active"
            :id="module.machine_name">
          <label class="form-check-label" for="dining">
            {{ module.config.title}}
          </label>
        </div>

        <button
          class="btn btn-primary mt-4"
          @click="saveModules()"
        >Save Module Settings</button>
      </div><!-- /settingsTab === 'modules' -->

    </div><!-- /.container -->
  </section>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../../firebaseConfig.js')

    export default {
      data() {
        return {
          settingsTab: 'user',
          newPassword: '',
          newEmail: '',
          showSuccess: false
        }
    },
    computed: {
      ...mapState([
        'userProfile',
        'currentUser',
        'admin',
        'dashboard',
        'modules'
      ])
    },
    methods: {
      installModule(module) {
        let self = this
        let confirmed = confirm("Would you like to install the " + module.config.title + " module?")
        self.dashboard.data.modules[module.machine_name] = module.config
        fb.dashboardsCollection.doc(self.dashboard.data.id).update({
          modules: self.dashboard.data.modules
        }).then(e => {
          const revData = self.dashboard.data
          revData.updatedOn = new Date()
          fb.dashboardRevisionsCollection.add(revData)
          alert('Successfully installed module')
          self.$store.commit('fetchDashboard', {id: self.$route.params.id, customStyles: false})
        }).catch(function(err){
          console.log(err.message)
        })
      },
      saveModules() {
        let self = this
        fb.dashboardsCollection.doc(self.dashboard.data.id).update({
          modules: self.dashboard.data.modules
        }).then(e => {
          const revData = self.dashboard.data
          revData.updatedOn = new Date()
          fb.dashboardRevisionsCollection.add(revData)
          alert('Successfully updated module settings')
          self.$store.commit('fetchDashboard', {id: self.$route.params.id, customStyles: false})
        })
      },
      updateEmail() {
        let self = this
        fb.auth.currentUser.updateEmail(this.newEmail).then(function(){
          //Do something
          fb.usersCollection.doc(self.currentUser.uid).update({
            email: self.newEmail
          })
          alert('Successfully updated your email!')
          self.newEmail = ''
        }).catch(function(err){
          //Do something
          alert(err.message)
        })
      },
      updatePassword() {
        let self = this
        fb.auth.currentUser.updatePassword(this.newPassword).then(function(){
          //Do something
          alert('Successfully updated your password!')
          self.newPassword = ''
        }).catch(function(err){
          //Do something
          alert(err.message)
        })
      },
      logout() {
        fb.auth.signOut().then(() => {
          this.$router.push('/login')
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/Settings.vue